import React, { useRef } from "react";
import { Row, Col } from "react-bootstrap";
import helpers from "@helpers";
import { BaseForm, BaseFieldSet, BaseDropdown } from "react-epharma-components";

const Search: React.FC = (props) => {
  const benefit = useRef<BaseDropdown>(null);
  const inputRefs = [benefit];

  return (
    <BaseForm refs={inputRefs} {...props}>
      <BaseFieldSet legend="Filtros">
        <Row>
          <Col xl="12">
            <BaseDropdown name="benefitId" mapping="benefitId" label="Plano" type="number" required labelProperty="name" valueProperty="id" endpoint={helpers.endpoints.benefit} ref={benefit} identifier />
          </Col>
        </Row>
      </BaseFieldSet>
    </BaseForm>
  );
};

export default Search;
